import { ContractTransaction } from 'ethers'

export const waitTxn = async (execute: () => Promise<ContractTransaction>) => {
  const { wait } = await execute()
  return wait()
}
